import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxField, DropdownField, TextAreaField } from 'components';
import { reduxForm, propTypes, Field, formValueSelector } from 'redux-form';
import { mapStateToProps } from 'utils/redux-decorators';
import { Button } from 'components';

const selector = formValueSelector('sponsorForm');

const validate = (values) => {
  const errors = {};
  if (values.grantEisfAccess) {
    if (!values.studyId) {
      errors.studyId = 'Study is required';
    }
    if (!values.countryId) {
      errors.countryId = 'Country is required';
    }
  }
  return errors;
};

@mapStateToProps((state) => ({
  grantEisfAccess: selector(state, 'grantEisfAccess'),
}))
@reduxForm({
  form: 'sponsorForm',
  validate,
})
export class SponsorForm extends React.PureComponent {
  render() {
    const {
      handleSubmit,
      grantEisfAccess,
      studiesList,
      countriesList,
      onStudyChange,
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image mt-10 flex flex-column align-items-center justify-content-center"
      >
        <Field
          name="note"
          placeholder="Add notes for Research Site"
          component={TextAreaField}
          maxLength={1000}
        />
        <Field
          name="grantEisfAccess"
          label="Grant eISF access"
          component={CheckboxField}
          fieldClassName="mt-8"
        />
        {grantEisfAccess && (
          <>
            <Field
              name="studyId"
              component={DropdownField}
              list={studiesList}
              onInputChange={onStudyChange}
              dropUp
              disabled={!studiesList.length}
              initMessage="Study"
              initMessageClassName="dd-header-title__ligth"
              fieldClassName="mt-8"
            />
            <Field
              name="countryId"
              component={DropdownField}
              list={countriesList}
              initMessage="Country"
              initMessageClassName="dd-header-title__ligth"
              disabled={countriesList.length === 0}
              fieldClassName="mt-8"
            />
          </>
        )}
        <Button
          type="submit"
          className="_red mt-29"
          style={{ width: '180px' }}
          dataTestId="connect"
        >
          Connect
        </Button>
      </form>
    );
  }
}
